<template>
  <div>
    <b-navbar class="main-nav" :class="{dark: !isLight}">
      <b-navbar-nav>
        <b-nav-item :href="homeButtonRoute" @click="homeButtonClick($event)">
          <img class="logo" :src="isLight ? darkLogo : lightLogo" alt="Heurix Powered By Cyber-Duck">
        </b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav v-if="loggedIn" type="dark" class="ml-auto" is-nav>
        <b-nav-item-dropdown type="dark" right text="My Account" class="dd-nav">
          <b-dropdown-item @click="navigate('user.details')">
            Account Details
          </b-dropdown-item>
          <b-dropdown-item href="mailto:support@heurix.io">
            Support
          </b-dropdown-item>
          <b-dropdown-item @click="logout">
            Log out
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
    <p v-if="showBetaNotice" class="beta-notice text-center">
      Heurix is currently in Beta. If you have any ideas or feedback
      <a href="mailto:team@heurix.io">please tell us.</a>
    </p>
  </div>
</template>

<script>
  import apiMixin from "../../utils/api"
  import darkLogo from '../../assets/img/heurix_black.png'
  import lightLogo from '../../assets/img/heurix_cyberduck_logo.png'

  export default {
    name: 'NavigationNavbar',
    mixins: [apiMixin],
    props: {
      variant: {
        type: String,
        default: 'dark'
      },
      showBetaNotice: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        darkLogo,
        lightLogo,
        isLight: this.variant === 'light'
      }
    },
    computed: {
      loggedIn() {
        return this.$store.getters['user/loggedIn']
      },
      homeButtonRoute() {
        return this.loggedIn ? this.resolve('site.list') : this.resolve('user.login')
      }
    },
    methods: {
      async logout() {
        await this.delete("/api/users/me/session/")
        await this.$store.dispatch('user/logOut')
        this.navigate('user.login')
      },
      homeButtonClick(e) {
        this.loggedIn ? this.navigate('site.list', e) : this.navigate('user.login', e)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/scss/variables";
  .main-nav {
    margin: 0;
    padding-top: 0;
    padding-bottom: 0;

    &.dark {
      background-color: rgba($purple, 0.9);
    }
  }

  .logo {
    max-height: 6em;
    margin-left: 1em;
  }

  ::v-deep .nav-link span, ::v-deep .nav-link:after {
    color: white;
  }

  .beta-notice {
    background-color: #66b366;
    padding: .5em 3em;
    font-size: .95em;

    a, a:hover, a:visited, a:hover {
      color: white;
    }
  }
</style>
